import { useContext } from 'react';
import { AuthContext } from '../Context/Auth/index.js';

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be within a AuthContextProvider');
  }

  return context;
};

export default useAuth;
